/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const Notes: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M20 18H14L12 20L10 18H4C2.89543 18 2 17.1046 2 16V6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V16C22 17.1046 21.1046 18 20 18ZM13.1716 16L12 17.1716L10.8284 16H5C4.44771 16 4 15.5523 4 15V7C4 6.44772 4.44772 6 5 6H19C19.5523 6 20 6.44772 20 7V15C20 15.5523 19.5523 16 19 16H13.1716ZM7.5 9.5C6.80964 9.5 6.25 10.0596 6.25 10.75C6.25 11.4404 6.80964 12 7.5 12C8.19036 12 8.75 11.4404 8.75 10.75C8.75 10.0596 8.19036 9.5 7.5 9.5ZM10.75 10.75C10.75 10.0596 11.3096 9.5 12 9.5C12.6904 9.5 13.25 10.0596 13.25 10.75C13.25 11.4404 12.6904 12 12 12C11.3096 12 10.75 11.4404 10.75 10.75ZM16.5 9.5C15.8096 9.5 15.25 10.0596 15.25 10.75C15.25 11.4404 15.8096 12 16.5 12C17.1904 12 17.75 11.4404 17.75 10.75C17.75 10.0596 17.1904 9.5 16.5 9.5Z" />

    </StyledIconBase>
  )
})

Notes.displayName = 'Notes'

export const NotesDimensions = {height: 24, width: 24}
